import type { ReactNode } from 'react';

interface SectionHeaderProps {
	title: string;
	action?: ReactNode;
}

/** Tiêu đề section kèm vạch gradient bên trái — giữ đúng motif của bản gốc. */
export function SectionHeader({ title, action }: SectionHeaderProps) {
	return (
		<div className="mb-4 flex items-center justify-between gap-4">
			<h2 className="flex items-center gap-2.5 text-[22px] font-bold">
				<span
					className="h-6 w-1 shrink-0 rounded bg-linear-to-b from-accent to-iris"
					aria-hidden="true"
				/>
				{title}
			</h2>
			{action}
		</div>
	);
}
